import { inject, Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'environments/environment';

@Injectable()
export class LangInterceptor implements HttpInterceptor {
  private readonly _translateService = inject(TranslateService);

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!request.url.startsWith(environment.apiUrl)) {
      return next.handle(request);
    }

    request = request.clone({
      setParams: { lang: this._translateService?.currentLang || 'es' }
    });

    return next.handle(request);
  }
}
